import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Typography } from '@matillion/component-library'

import { ReactComponent as PlayIcon } from 'assets/play.svg'

import { CreateCard, type CreateCardProps } from 'components/CreateCard'
import { DesignerModal } from 'components/DesignerModal/DesignerModal'

import classes from './PipelineCard.module.scss'
import { Stack } from './Stack'

export interface PipelineCardProps
  extends Omit<CreateCardProps, 'children' | 'ariaLabel'> {
  title: string
  description: string
  videoGuideURL: string
}

const VIDEO_TITLE_ID = 'video-guide-title'

export function PipelineCard({
  title,
  description,
  videoGuideURL,
  ...cardProps
}: Readonly<PipelineCardProps>) {
  const [modalOpen, setModalOpen] = useState(false)
  const { t } = useTranslation()
  return (
    <>
      <CreateCard {...cardProps} ariaLabel={title}>
        <Stack>
          <Typography format="tm">{title}</Typography>
          <Typography>{description}</Typography>
        </Stack>
        <Button
          className={classes.PipelineCard__PlayButton}
          alt="text"
          as="a"
          onClick={(e) => {
            e.stopPropagation()
            setModalOpen(true)
          }}
        >
          <PlayIcon /> {t('translation:canvas.noJobSelectedWatchBtn')}
        </Button>
      </CreateCard>
      {modalOpen && (
        <DesignerModal
          size="large"
          ariaLabelledBy={VIDEO_TITLE_ID}
          onCancel={() => {
            setModalOpen(false)
          }}
        >
          <div className={classes.Modal__Heading}>
            <Typography
              id={VIDEO_TITLE_ID}
              as="h2"
              format="tl"
              className={classes.Modal__Title}
            >
              {title}
            </Typography>
          </div>
          <iframe
            data-testid="pipeline-video-frame"
            allowFullScreen
            height="560px"
            width="100%"
            src={videoGuideURL}
          />
        </DesignerModal>
      )}
    </>
  )
}
